import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./UpdateProduct.css"; // Asegúrate de importar el archivo CSS
import UploadImaProd from "../components/UploadImageProd"; 

const UpdatePord = () => {
  const navigate = useNavigate();
  /*const [numberOfImages,setNumberOfOmages]=useState(1);*/

  const [formData, setFormData] = useState({
    customer_id: "",
    product_id: "",
    category: "",
    product_name: "",
    description: "",
    price: "",
    image: {url:"", color:"", size:""}


  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInfoChange = (e) => {
    const { name, value } = e.target;
    const updatedInfo = formData.info;
    updatedInfo[name] = value;
    setFormData({ ...formData, info: updatedInfo });
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    const infoData = formData.info;
    setFormData({ ...formData, info: JSON.stringify(infoData) });
    console.log('res:', formData);
    const response = await fetch('http://localhost:8000/api/uploadprod', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const json = await response.json();
    console.log('res:', json);
  };

  return (
    <div className="update-product-container">
      <form onSubmit={handleSubmit} className="form-container">
        <h1>Actualizar Producto</h1>

        {/* Navigation buttons */}
        <div className="navigation-buttons">
          <button onClick={() => navigate("/")} className="nav-button">Inicio</button>
          <button onClick={() => navigate("/about")} className="nav-button">Acerca de</button>
        </div>

        <div className="form-content">
          

          {/* Right Column: Form Inputs */}
          <div className="right-column">
            {/* Form fields */}
            <div className="form-fields">
              <label>
                <span>Customer ID:</span>
                <input
                  type="number"
                  name="customer_id"
                  value={formData.customer_id}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                <span>Producto:</span>
                <input
                  type="text"
                  name="product_name"
                  value={formData.product}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                <span>ID Producto:</span>
                <input
                  type="number"
                  name="product_id"
                  value={formData.product_id}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                <span>Tipo Producto:</span>
                <input
                  type="text"
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                <span>Descripción:</span>
                <input
                  type="text"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                />
              </label>


              <label>
                <span>Precio:</span>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  required
                />
              </label>

              


              <label>
                <span>Imagen URL:</span>
                <input
                  type="text"
                  name="image"
                  value={formData.image.url}
                  onChange={handleChange}
                  required
                />
              </label>

              {/* Info Section */}
              <h3>Información Adicional</h3>
              <div className="info-fields">
                
          

                <label>
                  <span>Imagen Color URL:</span>
                  <input
                    type="text"
                    name="image_color"
                    value={formData.image.color}
                    onChange={handleInfoChange}
                    required
                  />
                </label>

                <label>
                  <span>Tamaño:</span>
                  <input
                    type="text"
                    name="size"
                    value={formData.image.size}
                    onChange={handleInfoChange}
                    required
                  />
                </label>
              </div>

              {/* Submit Button */}
              <button type="submit" className="submit-btn">Enviar</button>
            </div>
          </div>
          {/* Left Column: Image Upload Section */}
          <div className="left-column">
            <UploadImaProd image={formData.image.url}/>
          </div>
        </div>
      </form>
    </div>
  );
};

export default UpdatePord;
